<template>
  <div v-if="popupVisible">
    <side-popup :title="title" :popupVisible="popupVisible" @onClose="onClose">
      <div class="w1500P75 revisionSkin">
        <ul>
          <li v-for="item in box.skin_list" :key="item.id" class="skin-li" :class="parseColor(item,'price_box','key',box.price)">
            <div class="li-div li-div-center">
              <div v-if="item.probability" class="rate">{{ item.probability }}%</div>
              <div class="bei">
                <img :src="item.imageUrl" class="img_active" />
              </div>
              <div class="name p-1">{{ item.itemName }}</div>
              <div class="money-warp">
                <img src="@/assets/images/money.png" class="money-img" />
                <span>{{ item.price }}</span>
              </div>
              <div class="color-line" :style="'background-color:'+parseColor(item,'price_box','color',box.price)"></div>
            </div>
          </li>
        </ul>
        <empty v-if="box.skin_list.length===0"></empty>
      </div>
    </side-popup>
  </div>
</template>

<script>
import SidePopup from "@/g-components/side-black-popup.vue";
// import SidePopup from "@/g-components/side-popup.vue";
import { parseColor } from "@/assets/js/util.js";
import empty from "@/g-components/empty.vue";

export default {
  components: {
    SidePopup,
    parseColor,
    empty
  },
  data() {
    return {
      box: {
        name: '',
        skin_list: [],
        content: ''
      },
      parseColor,
      isMobile: false,
      title: '加载中',
      popupVisible: false
    }
  },
  created() {
    // this.toggle('Member')
  },
  methods: {
    onClose() {
      this.popupVisible = false
      this.$emit('onClose', 'onClose')
    },
    toggle(data) {
      this.isMobile = window.innerWidth < 600
      this.title = data.name + '详情'
      // data.skin_list 根据价格倒序
      data.skin_list.sort((a, b) => b.price - a.price)
      this.box = data
      this.popupVisible = true
    }
  }
};
</script>
